import SelectAnalyst from '../solicitations/select.analyst.component';
import SelectFaciliterReviewer from '../solicitations/select.faciliter.reviewer.component';
import SelectReviewers from '../solicitations/select.reviewers.component';

function RequestReviewResponsiblesComponent({ request, refresh }) {

    return (
        <>
            <SelectReviewers
                type={request.type}
                requestId={request.id}
                reviewers={request.reviewers}
            />

            <SelectFaciliterReviewer
                requestId={request.id}
                faciliterReviewer={(request.faciliterReviewers || [])[0]}
                operationalDueDate={request.operationalDueDate}
                clientDueDate={request.dueDate}
                callback={refresh}
            />

            <SelectAnalyst
                type={request.type}
                requestId={request.id}
                analysts={request.analysts}
                onRefreshRequest={refresh}
            />
        </>
    );
}

export default RequestReviewResponsiblesComponent;
